import React, { useEffect} from "react";
import { connect } from "react-redux";
import Card from "components/card";
import JobPostCard from "./JobPostCard";
import { getJobPostList, getJobPostDetails } from "../../../../redux/jobpost/jobPostState";

const JobListPanel = ({ recordList, pagination, doSearch, filters, selectedJob, getRecord }) => {

    useEffect(() => {
        doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

    const onSelectJobHanlder = (id) => {
        getRecord(id);
    }
    
    return (
        <Card className="flex flex-col gap-6 rounded-2xl border-2 border-slate-200 shadow-lg overflow-hidden h-full">
            <div className="px-6 pt-6 pb-6 bg-gradient-to-br from-cyan-50 to-emerald-50 border-b rounded-t-xl grid gap-1.5">
                <h4 className="text-[20px] font-medium">
                    Job Post Listings
                </h4>
                <p className="text-[15px] font-normal text-slate-700">
                    Select to view job details
                </p>
            </div>
            <div className="p-4 pb-6">
                <div className="space-y-3 overflow-y-auto">
                    {recordList.map((job) => (
                        <JobPostCard
                            recordData={job}
                            selected={selectedJob?.jpo_id === job.jpo_id}
                            onSelectHandler={onSelectJobHanlder}
                        />
                    ))}
                </div>
            </div>
        </Card>
    );
};

const mapStateToProps = (state) => ({
    recordList: state.jobPost.jobPostList?.items,
	pagination: state.jobPost.jobPostList?.pagination,
	filters: state.jobPost.jobPostList?.filters,
  	requesting: state.jobPost.jobPostList?.requesting,
  	error: state.jobPost.jobPostList?.error,
    selectedJob: state.jobPost.jobPostDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getJobPostList(filters)),
    getRecord: (id) => dispatch(getJobPostDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobListPanel);